export default "__VITE_ASSET__CfHG3$Py__"